import React, {  useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import PageTabing from '../../component/PageTabing';
import PageFilter from '../../component/PageFilter';
import { fetchSheetData } from '../../api/mappingApi';
import SheetTable from './SheetTable';
import SearchingFilter from '../../component/SearchingFilter';
import SearchBox from '../../component/SearchBox';
import {  AccessGroup, ActiveInactiveBooleanOptions, BaudRateOptions, boolOptions, checkBooleanVal, DefaultSiteTechGroup, EngineSequencerStateOptions, ExerciseStateOptions, FuelTypeOptions, GaugeType, GenControllerStateOptions, LeadingLaggingNgcOptions, OnOffBooleanOptions, OpenClosedBooleanOptions, paramOptions, PhaseRotationBooleanOptions, PowerApplicationModeOptions, RedundantStarterModeOptions, SensorSelectOptions, UnitOptions, VoltagePhaseConnectionOptions, YesNoBooleanOptions } from '../../constants';
import Loader from '../../component/Loader/Loader';
// import ModalDropDown from '../Events/ModalDropDown';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DropDownParam from '../../component/DropDownParam/DropDownParam';
import Divider from '@mui/material/Divider';
import swal from 'sweetalert';
import TextFormField from './TextFormField';
import NumberAndFloatFormField from './NumberAndFloatFormField';
import FormNumberField from '../../component/NumberInput';

const Parameters = () => {
  
  const [page, setPage]                         = React.useState(0);
  const [showLoader, setShowLoader]             = React.useState(false);
  const [showForm, setShowForm]                 = React.useState(false);
  const [rowsPerPage, setRowsPerPage]           = React.useState(100);
  const [sheetMappingData, setSheetMappingData] = React.useState([]);
  const [sheetFilter, setSheetFilter]           = React.useState('');
  const [searchByFilter, setSearchByFilter]     = React.useState('');
  const [searchLabel, setSearchLabel]           = React.useState('CTag / MBDTag');
  const [searchValue, setSearchValue]           = React.useState('');
  const [showSearchForm, setShowSearchForm]     = React.useState(false);
  const [showLanagueField, setShowLanagueField] = React.useState(true);
  const [updatedField, setUpdatedField]         = React.useState([]);
  const [editRowDataType, setEditRowDataType]   = React.useState('');
  const [editRowData, setEditRowData]           = React.useState({
    Addr:   '',
    ETxt:   '',
    FTxt:   '',
    STxt:   '',
    GTxt:   '',
    ITxt:   '',
    DTxt:   '',
    NTxt:   '',
    PTxt:   '',
    PeTxt:  '',
    TTxt:   '',
    CTxt:   '',
    RTxt:   '',
    Min:    '',
    Max:    '',
    Val:    '',
    Unit:   '',
    RAccs:  '',
    WAccs:  '',
    GType:  '',
    GName:  '',
    CST:    ''
  })

  React.useEffect(() => {
    if(sheetFilter !== ''){
      fetchData(page,rowsPerPage,sheetFilter,searchByFilter,searchValue);
    }
  },[page,rowsPerPage,sheetFilter,searchByFilter]);

  const fetchData = async (page,rowsPerPage,sheetFilter,searchByFilter,searchValue) => {
    setShowLoader(true);
    const data = await fetchSheetData(page,rowsPerPage,sheetFilter,searchByFilter,searchValue);
    setShowLoader(false);
    setSheetMappingData(data);
  }

  const handleSearch = async () => {
    if(searchValue !== ''){
      if(page > 0){
        setPage(0); 
      } else {
        fetchData(page,rowsPerPage,sheetFilter,searchByFilter,searchValue);
      }
    }
  }

  const handleClearSearch = () => {
    setSearchValue('');
    fetchData(page,rowsPerPage,sheetFilter,searchByFilter,'');
  }
 

  const handleSheetFilter = (e) => {
    setShowForm(false);
    setSheetFilter(e.target.value)
  }

  const handleChangePage = (event, pageVal) => {
    setPage(pageVal);
  }

  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value === 'ALL' ? -1 : parseInt(event.target.value,10)
    setRowsPerPage(value);
    setPage(0);
  }

  const handleEditRow = (row) => {
   // console.log('unit',row.DefaultUnits)
    setShowForm(true);
    setEditRowDataType(row.DataType)
    setEditRowData({
      Addr: row.Address,
      ETxt: row.EnglishText,
      FTxt: row.FrenchText,
      STxt: row.SpanishText,
      GTxt: row.GermanText,
      ITxt: row.ItalianText,
      DTxt: row.DutchText,
      NTxt: row.NorwegianText,
      PTxt: row.PolishText,
      PeTxt: row.PortugueseText,
      TTxt: row.TurkishText,
      CTxt: row.ChineseText,
      RTxt: row.RussianText,
      Min: row.DefaultMinValue,
      Max: row.DefaultMaxValue,
      Val: row.DefaultValue,
      Unit: row.DefaultUnits,
      RAccs: row.DefaultSiteTechReadAccess,
      WAccs: row.DefaultSiteTechWriteAccess,
      GType: row.Gauge,
      GName: row.DefaultSiteTechGroup,
      CST: row.CST
    });
    setUpdatedField({});
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  const handleSubmitRowLocalStorage = () => {
    
    let existingParam = JSON.parse(localStorage.getItem('Parameters'));
    if(existingParam == null) existingParam = [];
    let isExist = false;
    
    // if(updatedField?.RAccs){
    //   const selectedOption = AccessGroup.find(option => option.value === updatedField.RAccs);
    //   updatedField.RAccs   = selectedOption?.data_value; 
    // }  

    // if(updatedField?.WAccs){
    //   const selectedOption = AccessGroup.find(option => option.value === updatedField.WAccs);
    //   updatedField.WAccs   = selectedOption?.data_value; 
    // } 

    // if(updatedField?.GType){
    //   const selectedOption = GaugeType.find(option => option.value === updatedField.GType);
    //   updatedField.GType   = selectedOption?.data_value; 
    // } 

    // if(updatedField?.Unit){
    //   const selectedOption = UnitOptions.find(option => option.value === updatedField.Unit);
    //   updatedField.Unit    = selectedOption?.data_value; 
    // } 

    // if(updatedField?.GName){
    //   const selectedOption = DefaultSiteTechGroup.find(option => option.value === updatedField.GName);
    //   updatedField.GName     = selectedOption?.data_value; 
    // }

    let valdationStatus = false;
    Object.keys(updatedField).forEach(function(key) {
        const result = decimalValidation(key,updatedField[key]);
        if(result){
            valdationStatus = true;
        }        
    });
  
    if(valdationStatus){
      if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double'){
        swal("Oops!", "Please use Float value for Min, Max and Default Val!", "error");
      } 
      // else {
      //   swal("Oops!", "Please use Float value for Min and Max!", "error");
      // }
      return false;
    }
    
    if(existingParam != null && existingParam.length > 0){
      existingParam =  existingParam.map((param) =>  {
        if(param.Addr === updatedField.Addr){
          isExist = true;
          return {...param,...updatedField}
        } else {
          return param;
        }
      });
    } 
    if(!isExist){
      existingParam.push(updatedField);
    }
    localStorage.setItem('Parameters',JSON.stringify(existingParam));
    window.dispatchEvent(new Event('storage'));
    setShowForm(false);
  }  

  
  useEffect(() => {
    setUpdatedField((prevUpdateField) => ({...prevUpdateField, Addr: editRowData.Addr }));
  },[editRowData])
  
  const decimalValidation = (name,value) => {
    let validationArray = [];
    if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double'){
       console.log('if condition');
      validationArray = ['Min','Max','Val'];
    } 
    // else {
    //   validationArray = ['Min','Max'];
    // }
    if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
      return true;
    } 
    return false;
  }

  const handleSearchByFilter = (e) => {
    if(e.target.value === '1'){
      setSearchLabel('CTag / MBDTag');
    } else {
      setSearchLabel('English Text');
    }
    if(e.target.value !== ''){
      setSearchByFilter(e.target.value);
      setShowSearchForm(true);
    } else {
      setShowSearchForm(false);
      setSearchByFilter('');
      setSearchValue('');
    }
  }  

  const handleChangeTextValue = (event) => {
    setSearchValue(event.target.value);
  }


  const handleDropDownChange = (e) => {
    const {name,value} = e.target;
    let finalVal;
    if(name === 'RAccs' || name === 'WAccs' || name === 'GType' || name === 'Unit' || name === 'GName'){
      finalVal = name === 'Unit' ? value.replaceAll(/\s/g,'') :  value;
    } else {
      finalVal = parseInt(value);
    }
    
    setEditRowData((prevState) => ({...prevState, [name]: finalVal}));
    setUpdatedField((prevUpdateField) => ({...prevUpdateField, [name]: finalVal }));
    //handleBlurUpdate(name,value);
    //console.log('name -- value',name+'---'+value)
    // let selectedOption;
    // if(name === 'RAccs' || name === 'WAccs'){
    //   selectedOption = AccessGroup.find(option => option.value === value);
    // } else if (name === 'GType') {
    //   selectedOption = GaugeType.find(option => option.value === value);
    // } else {
    //   selectedOption = UnitOptions.find(option => option.value === value);
    // }
    //console.log('selected option', selectedOption?.value)
    //handleBlurUpdate(name,selectedOption?.value);
  }  

  
  // const handleLanguageField = () => {
  //   setShowLanagueField(true);
  // }


  const handleDropDownChangeBoolean = (e) => {
    const {name,value} = e.target;
    const boolValue =value === true || value === "true" || value === 1 || value === "1";
    setEditRowData((prevState) => ({...prevState, [name]: boolValue}));
    setUpdatedField((prevUpdateField) => ({...prevUpdateField, [name]: boolValue }));
  }  

  const changeHandler = useCallback((name,value) => {
    setEditRowData((prevState) => ({...prevState, [name]: value }));
    setUpdatedField((prevUpdateField) => ({...prevUpdateField, [name]: value }));
  }, []);

  const changeHandlerFloat = useCallback((name,value) => {
    const result = decimalValidation(name,value);
    if(result){
      if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double'){
        swal("Oops!", "Please use Float value for Min, Max and Default Val!", "error");
      } else {
        swal("Oops!", "Please use Float value for Min and Max!", "error");
      }
    }
    if(value % 1 === 0){
      value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
    }
    let finalValue = parseFloat(value);
    setEditRowData((prevState) => ({...prevState, [name]: finalValue }));
    setUpdatedField((prevUpdateField) => ({...prevUpdateField, [name]: finalValue }));
  }, []);

  const changeHandlerInteger = useCallback((name,value) => {
    setEditRowData((prevState) => ({...prevState, [name]: parseInt(value) }));
    setUpdatedField((prevUpdateField) => ({...prevUpdateField, [name]: parseInt(value) }));
  }, []);

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb  title="Paramters">
        <Typography component={Link} to="/" variant="subtitle2" color="primary"  className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
          Paramters
        </Typography>
      </Breadcrumb>
      <PageTabing value="param" />
      <Box  component="section">
        <Grid className="contentBox">
          <Grid container direction="row" sx={{pb: { xs: 2 }}} spacing={2}>
            <Grid item xs={12} sm={4} md={3} >
            
              <PageFilter 
                options={paramOptions}
                //width={90}
                filterValue={sheetFilter}
                handleSheetFilter={handleSheetFilter} 
              />
            </Grid>
            {sheetFilter !== '' &&
              <Grid item xs={12} sm={4} md={3}>
                <SearchingFilter 
                  //width={90}
                  value={searchByFilter}
                  handleSearchByFilter={handleSearchByFilter} 
                />
              </Grid>
            }
            {sheetFilter && showSearchForm &&
              <Grid item xs={12} sm={4} md={4}>
                <SearchBox 
                  label={searchLabel}
                  value={searchValue}
                  handleChangeTextValue = {handleChangeTextValue}
                  handleSearch={handleSearch}
                  handleClearSearch={handleClearSearch}
                />
                
              </Grid>
            }
          </Grid>
          
          {showForm &&
            <>
            
            <Divider sx={{mb:2}} />
            <Grid className='editParamFields' container sx={{ mb: 2, display: 'flex' }}>
              { Object.keys(editRowData).map((field) => {
                let columnLabel;
                if(field === 'Addr'){
                  columnLabel = 'Address';
                } else {
                  columnLabel = sheetMappingData?.labels?.find(label => label.column_key_name === field)?.column_name || field;
                }
                if(field === 'RAccs' || field === 'WAccs' || field === 'GType' || field === 'Unit' || field === 'GName'){
                  return (
                    <DropDownParam
                      width={false}
                      label={columnLabel}
                      name={field}
                      key={field}
                      value={(field === 'Unit' && editRowData[field] === '') ?  ' ' : editRowData[field] || ""}
                      options={field === 'GType' ? GaugeType : field === 'Unit' ? UnitOptions : field === 'GName' ? DefaultSiteTechGroup : AccessGroup}
                      handleDropDownChange={handleDropDownChange}
                    />
                  )
                } else if(field === 'Min' || field === 'Max'){
                  if(editRowDataType?.toLowerCase() === 'string'){
                    return (
                      <TextFormField
                        width={false}
                        label={columnLabel} 
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandler} 
                      />
                    )
                   } else if(editRowDataType?.toLowerCase() === 'int8' || editRowDataType?.toLowerCase() === 'int16' || editRowDataType?.toLowerCase() === 'int32' || editRowDataType?.toLowerCase() === 'int64' || editRowDataType?.toLowerCase() === 'uint8' || editRowDataType?.toLowerCase() === 'uint16' || editRowDataType?.toLowerCase() === 'uint32' || editRowDataType?.toLowerCase() === 'uint64') {
                    
                    return (
                      <NumberAndFloatFormField 
                        label={columnLabel}
                        width={false}
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandlerInteger}
                        type="int"
                      />
                    ) 
                   } else if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double') {
                      return(
                        <NumberAndFloatFormField 
                          label={columnLabel}
                          width={false}
                          name={field} 
                          value={editRowData[field]} 
                          onHandleChange={changeHandlerFloat}
                        />
                      )
                  } else if(editRowDataType?.toLowerCase() === 'activeinactiveboolean' || editRowDataType?.toLowerCase() === 'bool' || editRowDataType?.toLowerCase() === 'boolean' || editRowDataType?.toLowerCase() === 'openclosedboolean' || editRowDataType?.toLowerCase() === 'yesnoboolean' || editRowDataType?.toLowerCase() === 'leadinglaggingboolean' || editRowDataType?.toLowerCase() === 'phaserotationboolean' || editRowDataType?.toLowerCase() === 'onoffboolean') {
                    return(
                      <NumberAndFloatFormField 
                        label={columnLabel}
                        width={false}
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandlerInteger}
                        type="int"
                      />
                    )
                  } else {
                    return(
                      <NumberAndFloatFormField 
                        label={columnLabel}
                        width={false}
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandlerInteger}
                        type="int"
                      />
                    )
                  }
                } else if(field === 'Val') {
                  if(editRowDataType?.toLowerCase() === 'string'){
                    return (
                      <TextFormField
                        width={false}
                        label={columnLabel} 
                        name={field} 
                        value={editRowData[field] ?? ""} 
                        onHandleChange={changeHandler} 
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'boolean' || editRowDataType?.toLowerCase() === 'bool') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={boolOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'fueltype') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={FuelTypeOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'yesnoboolean') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={YesNoBooleanOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'openclosedboolean') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={OpenClosedBooleanOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'activeinactiveboolean') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={ActiveInactiveBooleanOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'baudrate') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={BaudRateOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'exercisestate') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={ExerciseStateOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'sensorselect') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={SensorSelectOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'leadinglaggingboolean') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={LeadingLaggingNgcOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'onoffboolean') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={OnOffBooleanOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'phaserotationboolean') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={checkBooleanVal(editRowData[field])}
                        options={PhaseRotationBooleanOptions}
                        handleDropDownChange={handleDropDownChangeBoolean}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'gencontrollerstate') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={GenControllerStateOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'voltagephaseconnection') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={VoltagePhaseConnectionOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'powerapplicationmode') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={PowerApplicationModeOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'redundantstartermode') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={RedundantStarterModeOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'enginesequencerstate') { 
                    return (
                      <DropDownParam
                        width={false}
                        label={columnLabel}
                        name={field}
                        key={field}
                        value={editRowData[field]?.toString() || ""}
                        options={EngineSequencerStateOptions}
                        handleDropDownChange={handleDropDownChange}
                      />
                    )
                  } else if(editRowDataType?.toLowerCase() === 'int8' || editRowDataType?.toLowerCase() === 'int16' || editRowDataType?.toLowerCase() === 'int32' || editRowDataType?.toLowerCase() === 'int64' || editRowDataType?.toLowerCase() === 'uint8' || editRowDataType?.toLowerCase() === 'uint16' || editRowDataType?.toLowerCase() === 'uint32' || editRowDataType?.toLowerCase() === 'uint64') {
                    return (
                      <NumberAndFloatFormField 
                        label={columnLabel}
                        width={false}
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandlerInteger}
                        type="int"
                      />
                    ) 
                  } else if(editRowDataType?.toLowerCase() === 'float' || editRowDataType?.toLowerCase() === 'double') {
                    return (
                      <NumberAndFloatFormField 
                        label={columnLabel}
                        width={false}
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandlerFloat}
                      />
                    ) 
                  } else {
                    return (
                      <NumberAndFloatFormField 
                        label={columnLabel}
                        width={false}
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandlerInteger}
                        type="int"
                      />
                    ) 
                  }
                } 
                else {
                 if((field === 'Addr' || field === 'ETxt' || field === 'CST') && showLanagueField === true){
                    return (
                      <TextFormField 
                        label={field === 'CST' ? 'Custom Text'  : columnLabel} 
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandler} 
                        width={false}
                      />
                    )
                  }

                  if(showLanagueField === false){
                    return (
                      <TextFormField 
                        label={field === 'CST' ? 'Custom Text'  : columnLabel} 
                        name={field} 
                        value={editRowData[field]} 
                        onHandleChange={changeHandler} 
                        width={false}
                      />
                    )
                  }
                }
                return null;
              })}
            </Grid>
              <Button sx={{ mb: 2,mr:2 }} size="small" color="primary" onClick={handleSubmitRowLocalStorage} variant="contained">Submit</Button>
              <Button sx={{ mb: 2 }} size="small" color="secondary" onClick={() => showLanagueField ? setShowLanagueField(false) : setShowLanagueField(true) } variant="contained">{showLanagueField ? 'Show Language Fields'  : 'Hide Language Fields' }</Button>
            </>
          }
          {sheetFilter !== '' &&
            <SheetTable 
              page             = {page} 
              rowsPerPage      = {rowsPerPage}
              handleEditRow    = {handleEditRow}
              sheetMappingData = {sheetMappingData}
              handleChangePage = {handleChangePage}
              handleChangeRowsPerPage = {handleChangeRowsPerPage}
            />
          }
         
        </Grid>
      </Box>
    </>
  );
};

export default Parameters;
